"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _WafContent = require("./WafContent");
Object.keys(_WafContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _WafContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WafContent[key];
    }
  });
});
